import { observer } from 'mobx-react';
import React from 'react';
import userSettingEnum from '../../../../constants/enums/user-setting-enum';
import { useStore } from '../../../../contexts/store-provider';
import { IFormModalProps } from '../../../../models/forms/IForm';
import DefaultModal from '../../../../shared-components/modal/default-modal';
import HKRColumnReorderForm, {
  IHKRColumnItem,
} from '../forms/hkr-column-reorder-form';

interface IProps extends IFormModalProps {
  allColumns: string[];
  selectedColumns: string[];
  // receives the visible (non-hidden) columns in their new order
  onSubmitReorder: (orderedVisibleColumns: string[]) => void;
}

const HKRColumnReorder = (props: IProps) => {
  const { activeTrayManagementStore } = useStore();
  const { SaveProcessOrderService } = activeTrayManagementStore;

  const onSubmitForm = (values: IHKRColumnItem[]) => {
    const orderedColumns = values
      .filter((item) => !item.IsHidden)
      .map((item) => item.id);
    SaveProcessOrderService({
      SettingKey: userSettingEnum.HKRTableColumn,
      ProcessOrder: orderedColumns.join(','),
    });
    props.onSubmitReorder(orderedColumns);
    props.modalClosed();
  };

  return (
    <React.Fragment>
      <DefaultModal
        id={props.id}
        className=""
        addHeader="reorder_process"
        updateHeader="reorder_process"
        onModalClosed={props.modalClosed}
        isLoading={false}
      >
        <HKRColumnReorderForm
          id={-1}
          initialValues={{}}
          isLoading={false}
          onModalClosed={props.modalClosed}
          submitHandler={onSubmitForm}
          allColumns={props.allColumns}
          selectedColumns={props.selectedColumns}
        />
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(HKRColumnReorder);
